module.exports = {
  eventCategory: 'Editor UI | Tool Menu | icons',

  show: { eventAction: 'show' }
};
